/* =============================================================================
   entry-popup.js: the two-step arrival popup (snippets/entry-popup, rendered from
   layout/theme.liquid on every template). Shares nothing with pdp-clips.js.

   FLOW
     step 1  a question — four concern buttons. Choosing one writes the concern
             into the form's contact[tags] and moves to step 2. No email yet:
             asking for a click first is what makes step 2 convert.
     step 2  Shopify's native customer form. Submitting posts to /contact#…,
             Shopify redirects back with ?customer_posted=true.
     step 3  shown on that bounce-back — a button through /discount/NEWME10 so the
             code is on the cart before they shop. It auto-follows after 1.2s.

   FREQUENCY
   - once per session (sessionStorage), and nothing for 30 days after a dismissal
     or a signup (localStorage 'und-entry-until'). A shopper who said no is not
     asked again on the next page.
   - never on /cart (the Liquid does not render it there) and never during checkout
     (checkout is Shopify's own domain and never loads theme code).

   BEHAVIOUR
   - opens with showModal() after data-entry-delay (default 4s), so it lands after
     the first paint rather than fighting it.
   - Escape, the ×, the two "No thanks" links and a backdrop click all close it and
     write the 30-day suppression. Closing never blocks the page.
   - the concern is stored in sessionStorage too, so the footer form can carry the
     same tag if the shopper signs up there instead.
   Tailwind scans assets/*.js; this file sets no classes (only [hidden]).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__entryPopup) return;
  window.__entryPopup = true;

  var SESSION = 'und-entry-seen';
  var UNTIL = 'und-entry-until';
  var CONCERN = 'und-entry-concern';
  var THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;

  function suppressed() {
    try {
      if (sessionStorage.getItem(SESSION) === '1') return true;
      var until = Number(localStorage.getItem(UNTIL) || 0);
      return until > Date.now();
    } catch (e) {
      return false;
    }
  }
  function suppress() {
    try {
      sessionStorage.setItem(SESSION, '1');
      localStorage.setItem(UNTIL, String(Date.now() + THIRTY_DAYS));
    } catch (e) {}
  }

  function init() {
    var dialog = document.querySelector('[data-entry-popup]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var steps = {
      1: dialog.querySelector('[data-entry-step="1"]'),
      2: dialog.querySelector('[data-entry-step="2"]'),
      3: dialog.querySelector('[data-entry-step="3"]'),
    };
    var tags = dialog.querySelector('[data-entry-tags]');
    var claim = dialog.querySelector('[data-entry-claim]');
    var posted = /[?&]customer_posted=true/.test(window.location.search);

    function show(n) {
      Object.keys(steps).forEach(function (k) {
        if (steps[k]) steps[k].hidden = String(k) !== String(n);
      });
    }

    function open(n) {
      show(n);
      if (!dialog.open) dialog.showModal();
      var focusable = steps[n] && steps[n].querySelector('button, input');
      if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 60);
    }

    function close() {
      suppress();
      if (dialog.open) dialog.close();
    }

    // came back from Shopify with the signup accepted: straight to the reward
    if (posted) {
      suppress();
      open(3);
      if (claim) setTimeout(function () { claim.click(); }, 1200);
      return;
    }

    if (suppressed()) return;

    dialog.querySelectorAll('[data-entry-concern]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var concern = btn.getAttribute('data-entry-concern') || '';
        if (tags) tags.value = 'prospect, ' + concern;
        try { sessionStorage.setItem(CONCERN, concern); } catch (e) {}
        open(2);
      });
    });

    dialog.querySelectorAll('[data-entry-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    dialog.addEventListener('cancel', function () { suppress(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });

    var delay = Number(dialog.getAttribute('data-entry-delay') || 4000);
    setTimeout(function () {
      if (!suppressed()) { try { sessionStorage.setItem(SESSION, '1'); } catch (e) {} open(1); }
    }, delay);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
